<script lang="ts">
  import { Link } from '@athena-lib/Link';
  import type { PaymentProviderIconsProps } from './types';

  const { paymentProviderIcons, action }: PaymentProviderIconsProps = $props();

  function chunk<T>(items: T[], maxItems: number) {
    const chunks: T[][] = [];
    for (const item of items) {
      let currentCunk = chunks[chunks.length - 1];
      if (!currentCunk) {
        currentCunk = [];
        chunks.push(currentCunk);
      }
      if (currentCunk.length >= maxItems) {
        currentCunk = [];
        chunks.push(currentCunk);
      }
      currentCunk.push(item);
    }
    return chunks;
  }

  function elementAction(node: HTMLDivElement, actionArg: unknown) {
    if (action) {
      return action(node, actionArg!);
    }
  }
</script>

<div class="max-w-128 md:flex">
  {#key paymentProviderIcons}
    {#each chunk(paymentProviderIcons, 3) as iconsChunk}
      <div class="mb-7 flex items-center justify-center md:mb-0 md:justify-start">
        {#each iconsChunk as paymentProviderIcon}
          <Link {...paymentProviderIcon.link} class="mr-10 block">
            <img
              src={paymentProviderIcon.icon.url}
              alt={paymentProviderIcon.icon.alt}
              loading="lazy"
              use:elementAction={paymentProviderIcon.actionArg}
            />
          </Link>
        {/each}
      </div>
    {/each}
  {/key}
</div>
